import Data from "../Data/Data.json";

// Base URL derivee de la config existante (aucun ajout requis dans Data.json)
const API_BASE = (Data.ApiUrl as any).ReadOperat.split("/api/")[0];

// Endpoints du module Conditions & Operations Liees
export const OpeApi = {
    // Referentiels (champs evaluables / operateurs)
    ReadChampsEval: `${API_BASE}/api/OpeCatalogue/ReadChamps`,
    ReadOperateursEval: `${API_BASE}/api/OpeCatalogue/ReadOperateurs`,

    // Conditions reutilisables
    ReadConditions: `${API_BASE}/api/OpeCondition/ReadConditions`,
    ReadCondition: `${API_BASE}/api/OpeCondition/ReadCondition`,
    CreateCondition: `${API_BASE}/api/OpeCondition/CreateCondition`,
    UpdateCondition: `${API_BASE}/api/OpeCondition/UpdateCondition`,
    DeleteCondition: `${API_BASE}/api/OpeCondition/DeleteCondition`,
    ReadUsages: `${API_BASE}/api/OpeCondition/ReadUsages`,

    // Groupes de conditions
    ReadGroupes: `${API_BASE}/api/GroupeCondition/ReadGroupes`,
    ReadGroupe: `${API_BASE}/api/GroupeCondition/ReadGroupe`,
    SaveGroupe: `${API_BASE}/api/GroupeCondition/SaveGroupe`,
    DeleteGroupe: `${API_BASE}/api/GroupeCondition/DeleteGroupe`,

    // Chaines d'operations liees + journal d'execution
    ReadChaine: `${API_BASE}/api/OperationLiees/ReadChaine`,
    SaveChaine: `${API_BASE}/api/OperationLiees/SaveChaine`,
    DeleteChaine: `${API_BASE}/api/OperationLiees/DeleteChaine`,
    ReadTraces: `${API_BASE}/api/OperationLiees/ReadTraces`
};
